<template>
  <a-drawer
:maskClosable="false"
width="60%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-descriptions :column="4" title="" class="full-width-descriptions">
      <a-descriptions-item label="广告所属">
        {{ form.typeCode }}
      </a-descriptions-item>
      <a-descriptions-item label="简介说明">
        {{ form.overviewVal }}
      </a-descriptions-item>
      <a-descriptions-item label="	跳转类型">
        {{ form.openType }}
        {{ form.openType == 0 ? '无动作' : form.openType == 1 ? '跳内文本' : '跳外部地址' }}
      </a-descriptions-item>
      <a-descriptions-item label="外部地址" v-if="(form.openType = 2)">
        {{ form.dataUrl }}
      </a-descriptions-item>
      <a-descriptions-item label="开始时间">
        {{ form.startTime }}
      </a-descriptions-item>
      <a-descriptions-item label="结束时间">
        {{ form.endTime }}
      </a-descriptions-item>
      <a-descriptions-item label="审核状态">
        {{ form.auditingState == 0 ? '审核中' : form.auditingState == 1 ? '审核通过' : '审核未通过' }}
      </a-descriptions-item>
      <a-descriptions-item label="审核人员" v-if="form.auditingState !== 0">
        {{ form.auditingUserName }}
      </a-descriptions-item>
      <a-descriptions-item label="审核时间	" v-if="form.auditingState !== 0">
        {{ form.auditingVal }}
      </a-descriptions-item>
      <a-descriptions-item label="审核说明" v-if="form.auditingState !== 0">
        {{ form.auditingVal }}
      </a-descriptions-item>
      <a-descriptions-item label="上架状态">
        {{ form.upState == 0 ? '下架' : '上架' }}
      </a-descriptions-item>
      <a-descriptions-item label="下架人员" v-if="form.dowUserName">
        {{ form.dowUserName }}
      </a-descriptions-item>
      <a-descriptions-item label="上架时间		" v-if="form.dowTime">
        {{ form.dowTime }}
      </a-descriptions-item>
      <a-descriptions-item label="图片">
        <div v-viewer>
          <img
            @error="
              (e) => {
                e.target.src = errorImage
              }
            "
            :src="$url + form.fileUrl"
            alt=""
            v-if="form.fileUrl"
          />
        </div>
      </a-descriptions-item>
      <!-- <a-descriptions-item label="详细地址" :span="2">
        {{ form.province }} {{ form.city }}{{ form.area }}{{ form.address }}</a-descriptions-item
      >
      <a-descriptions-item label="承诺保证" :span="2"> {{ form.commitmentIntroduce }} </a-descriptions-item>
      <a-descriptions-item label="服务介绍" :span="2"> {{ form.serviceIntroduce }} </a-descriptions-item>
      <a-descriptions-item label="备注" :span="2"> {{ form.remark }} </a-descriptions-item> -->
    </a-descriptions>
    <div v-if="form.openType == 1">
      详情文本
      <div v-html="form.detailsText" v-if="form.openType == 1"></div>
    </div>
  </a-drawer>
</template>
<script>
import { getObj, statusObj } from '@/api/pressure/carousel'
export default {
  name: 'Detail',
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      errorImage: require('/src/assets/images/defaultImg.png'),
      // 表单参数
      form: {},
      open: false,
      isShow: false,
      listType: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        auditingVal: [{ required: true, message: '请输入说明', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
     this.onClose()
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        typeId: undefined,
        title: undefined,
        fileUrl: undefined,
        openType: 0,
        detailsText: undefined,
        dataUrl: undefined,
        endTime: undefined,
        startTime: undefined,
        sort: 99,
        reservationTimes: [],
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加轮播'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      this.form.id = postId
      // this.formTitle = '详情'
      getObj(postId).then((response) => {
        console.log(response.data, 'responseresponseresponse')
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          statusObj(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
img {
  width: 50px;
  height: 50px;
}
</style>
